kv.controller('customFieldListCtrl', function ($element, $attrs, $scope, $injector) {
	return new dictionaryListCtrl($element, $attrs, $scope, $injector, {
		primaryKey: "custom_field_id",
		entity: "custom_field",
		modal: {
			templateUrl: "custom_field-edit",
			controller: "customFieldEditCtrl"
		}
	});
});
